import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { setMetaDescription } from 'utils';

const ScrollToTop = ({ history }) => {
  const setMeta = () => {
    document.title = `Barbr - Empowering barbers to thrive`;
    setMetaDescription(`Barbr is a platform that helps barbers save time, earn more and unlock their true potential.`);
  };

  useEffect(() => {
    // Disable browser scroll restoration globally to prevent scroll jumps
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    const unListen = history.listen(() => {
      setMeta();

      // Proper scroll reset for all browsers
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    });

    return () => {
      unListen();
    };
  }, [history]);

  return null;
};

export default withRouter(ScrollToTop);
